<template>
  <div>
    <vCard
      elevation="0"
      outlined
      tile
      class="location-card"
      :class="!!isNew && '--empty'"
      @click="handleOnOpenCurrentAddress"
    >
      <div class="location-content">
        <Icon :path="require('@/assets/icons/bubble-marker.svg')" width="4.3rem" class="location-icon" />
        <p class="location-title" v-if="!!isNew">{{ $t("add_first_primary_address") }}</p>
        <div class="address" v-if="!isNew">
          <p class="address-name">{{ value.label || "N/A" }}</p>
          <p class="address-details">{{ getAddressDetails }}</p>
        </div>
      </div>

      <v-chip outlined small color="primary" class="primary-tag" v-if="!!value.is_primary">
        {{ $t("primary_address") }}
      </v-chip>

      <div class="location-btn" v-if="!!isNew" @click="handleOnOpenCurrentAddress">
        <FIcon :name="'plus'" size="1.6rem" color="#42c3fe" />
      </div>

      <v-menu offset-y v-if="!isNew" :attach="attach">
        <template v-slot:activator="{ on, attrs }">
          <span class="dots" v-bind="attrs" v-on="on"> ... </span>
        </template>
        <v-list>
          <v-list-item @click="handleOnAddressMakePrimary(sort)" v-if="!value.is_primary">
            <v-list-item-title>{{ $t("make_primary") }}</v-list-item-title>
          </v-list-item>
          <v-list-item @click="handleOnDeleteCurrentAddress">
            <v-list-item-title class="error--text">{{ $t("delete_address") }}</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </vCard>
  </div>
</template>

<script>
import Vue from "vue";
import { CustomerAddressModule } from "@/modules/customer/address";
import { ResidentTextConstraints } from "@/enums/address.enum";

const AddressCard = Vue.extend({
  name: "AddressCard",

  data: () => ({
    lang: "en",
  }),

  props: {
    value: {
      type: Object,
      default: () => new CustomerAddressModule(),
    },

    empty: {
      default: false,
      type: Boolean,
    },

    primary: {
      default: false,
      type: Boolean,
    },

    attach: {
      default: "",
      type: String,
    },

    sort: {
      default: 0,
      type: Number,
    },

    isNew: {
      type: Boolean,
      default: false,
    },

    handleOnAddressDeleted: {
      type: Function,
    },
    handleOnAddressMakePrimary: {
      type: Function,
    },
    handleOnOpenAddressForm: {
      type: Function,
    },
  },

  mounted() {
    this.lang = this.$vuetify.lang.current;
  },

  computed: {
    getAddressDetails() {
      let text = "";
      if (_.isObject(this.value.city)) {
        text = this.value?.getCityName();
      }

      if (_.isObject(this.value.area)) {
        text = `${text} - ${this.value?.getAreaName()}`;
      }

      if (!_.isEmpty(this.value?.residence)) {
        text = `${text} - ${ResidentTextConstraints[this.value.residence]}`;
      }

      if (!_.isEmpty(this.value?.avenue)) {
        text = `${text} - ${this.value?.getAvenue()}`;
      }

      if (!_.isEmpty(this.value?.block)) {
        text = `${text} - ${this.value?.getBlock()}`;
      }

      if (!_.isEmpty(this.value?.street)) {
        text = `${text} - ${this.value.street}`;
      }

      if (!_.isEmpty(this.value?.building)) {
        text = `${text} - ${this.value.building}`;
      }

      if (!_.isEmpty(this.value?.floor)) {
        text = `${text} - ${this.value.floor}`;
      }

      if (!_.isEmpty(this.value?.apartment)) {
        text = `${text} - ${this.value.apartment}`;
      }

      return text;
    },
  },

  methods: {
    handleOnDeleteCurrentAddress() {
      this.handleOnAddressDeleted(this.value, this.sort);
    },

    handleOnOpenCurrentAddress() {
      this.handleOnOpenAddressForm(this.value, this.sort);
    },
  },
});
export default AddressCard;
</script>

<style lang="scss" src="./styles.scss" scoped />
